import script from "./HasPagination.vue?vue&type=script&lang=js"
export * from "./HasPagination.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__